import React from 'react';
import Text from './Text';
import * as G from '../game-info';

type GameVariant = keyof SizeOptions<any>;

interface SizeOptions<T> {
  jumbo: T[];
  normal: T[];
}

interface PortProps {
  port: G.Port;
  sideLength: number;
  xIncr: number;
  yIncr: number;
}

export default function Port({
  port,
  sideLength,
  xIncr,
  yIncr,
}: PortProps) {

  const x = xIncr * port.xIncrs;
  const y = yIncr * port.yIncrs;
  const offset1 = sideLength * 0.15;
  const rad1 = sideLength * 0.025;
  const offset2 = sideLength * 0.1;
  const rad2 = sideLength * 0.3;
  const strokeWidth = sideLength * 0.025;
  const textSize = sideLength * 0.1;
  const fill = '#000';
  const stroke = '#000';
  const textColor = '#fff';

  return (
    <g transform={`translate(${x}, ${y}) rotate(${port.angle})`} opacity="0.5">
      <circle
        cx={offset1 + rad1}
        cy={0}
        r={rad1}
        fill={stroke}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <line
        x1={offset1 + rad1 * 2}
        y1={0}
        x2={offset1 + rad1 * 2 + offset2}
        y2={0}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <circle
        cx={offset1 + rad1 * 2 + offset2 + rad2}
        cy={0}
        r={rad2}
        stroke={stroke}
        fill={fill}
        strokeWidth={strokeWidth}
      />
      <g transform={`translate(${offset1 + rad1 * 2 + offset2 + rad2} 0) rotate(${-port.angle})`}>
        <Text
          x={0}
          y={-textSize * 0.6}
          text={port.ratio}
          color={textColor}
          size={textSize * 2}
          align="center"
          weight="500"
        />
        <Text
          x={0}
          y={port.type === '?' ? textSize * 1.25 : textSize}
          text={port.type}
          color={textColor}
          size={port.type === '?' ? textSize * 2 : textSize}
          align="center"
          weight="600"
        />
      </g>
    </g>
  );
}
